import { ALL } from "../selected-group/constants";
import { useEntityAttributesContext } from "./context";
import { getAttributes } from "./utils";

export function useEntityAttributeById(attributeId: string) {
  const { data } = useEntityAttributesContext();

  const attribute = getAttributes(data, ALL).find(
    (attr) => attr.id === attributeId,
  );

  return attribute;
}
